const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { findActiveFilters } = require('utilities/filtersHelper');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ components
const ScheduledTransfersContentHeader = require('./scheduledTransfersContentHeader/scheduledTransfersContentHeader');
const ScheduledTransfersContentTable = require('./scheduledTransfersContentTable/scheduledTransfersContentTable');
const ScheduledTransfersContentFilters = require('./scheduledTransfersContentFilters/scheduledTransfersContentFilters');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ actions
const intervenersActions = require('actions/getAccountInterveners');

class ScheduledTransfersContent extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleRequestScheduledTransfers = this.handleRequestScheduledTransfers.bind(this);
    }

    componentDidMount() {
        const {
            immAccount,
            requestInterveners
        } = this.props;
        requestInterveners(immAccount.get('accountId'));
    }

    componentWillReceiveProps(nextProps) {
        const {
            immAccount,
            requestInterveners,
            resetInterveners
        } = this.props;
        const currentAccountId = immAccount.get('accountId');
        const nextAccountId = nextProps.immAccount.get('accountId');

        if (currentAccountId !== nextAccountId) {
            resetInterveners(currentAccountId);
            requestInterveners(nextAccountId);
        }
    }

    componentWillUnmount() {
        const {
            immAccount,
            resetInterveners
        } = this.props;
        resetInterveners(immAccount.get('accountId'));
    }

    handleRequestScheduledTransfers() {
        const accountId = this.props.immAccount.get('accountId');
        this.props.requestScheduledTransfers(accountId);
    }

    render() {
        const {
            immScheduledTransfers,
            immAccount,
            immAccounts,
            immFilter,
            immScreen,
            isInactiveAccountsEnabled,
            onClearFilters,
            onFilterClick,
            onResetFilter,
            requestScheduledTransfersNextPage
        } = this.props;
        const accountId = immAccount.get('accountId');
        const immAccountScheduledTransfers = immScheduledTransfers.get(accountId);
        const hasFilters = findActiveFilters(immFilter);
        let filters;
        let content;


        if (immAccountScheduledTransfers) {
            if (hasFilters) {
                filters = (
                    <ScheduledTransfersContentFilters
                        immFilter={immFilter}
                        onResetFilter={onResetFilter}
                        onClearFilters={onClearFilters}
                    />
                );
            }

            if (immAccountScheduledTransfers.get('loading')) {
                content = (<LoadingSection />);
            } else if (immAccountScheduledTransfers.get('error')) {
                const retryButton = (
                    <OKButton onClick={this.handleRequestScheduledTransfers}>
                        <FormattedText value="common-retry" />
                    </OKButton>
                );
                content = (
                    <EmptyState
                        button={retryButton}
                        primaryText={formatText('common-lostConnection')}
                        iconType="nointernet-banking" />
                );
            } else if (immAccountScheduledTransfers.get('byOrder').size > 0) {
                content = (
                    <ScheduledTransfersContentTable
                        immAccountScheduledTransfers={immAccountScheduledTransfers}
                        immScreen={immScreen}
                        accountId={accountId}
                        requestScheduledTransfersNextPage={requestScheduledTransfersNextPage}
                    />
                );
            } else {
                if (hasFilters) {
                    content = <EmptyState primaryText={formatText('transfersScheduled-hasFilterNoTransfersRetrieved')} iconType="transfer-banking"/>;
                } else {
                    const RETURN_TO_SCHEDULE_TRANSFERS_LINK = '/myprofile/transfers/transfer';
                    const SCHEDULE_TRANSFER_BUTTON = (
                        <OKButton
                            modifier="secondary"
                            to={RETURN_TO_SCHEDULE_TRANSFERS_LINK}
                        >
                            <FormattedText
                                format="uppercase"
                                value="transfersOptions-scheduleTransfer"
                            />
                        </OKButton>
                    );
                    content = (
                        <EmptyState
                            primaryText={formatText('transfersLanding-noScheduledTransfers')}
                            button={SCHEDULE_TRANSFER_BUTTON}
                            iconType="transfer-banking" />
                    );

                }
            }
        }

        return (
            <article className="scheduled-transfers-content">
                <ScheduledTransfersContentHeader
                    accountId={accountId}
                    immAccounts={immAccounts}
                    immFilter={immFilter}
                    isInactiveAccountsEnabled={isInactiveAccountsEnabled}
                    onFilterClick={onFilterClick}
                    onClearFilters={onClearFilters}
                />
                {filters}
                {content}
            </article>
        );
    }
}

ScheduledTransfersContent.propTypes = {
    immScheduledTransfers: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFilter: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    onFilterClick: PropTypes.func.isRequired,
    onResetFilter: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    requestScheduledTransfersNextPage: PropTypes.func.isRequired,
    requestScheduledTransfers: PropTypes.func.isRequired,
    resetInterveners: PropTypes.func.isRequired
};

module.exports.constructor = ScheduledTransfersContent;
module.exports.ScheduledTransfersContent = connect(null, {
    requestInterveners: intervenersActions.requestAccountInterveners,
    resetInterveners: intervenersActions.resetAccountInterveners
})(ScheduledTransfersContent);
